import { PIXI } from '@colonist/pixi';
import { UIGameToolTipController } from '../../../../shared/scripts/ui_game/ui_game_tooltip/UIGameToolTipController.ts';
import { UIMGameToolTipView } from './UIMGameToolTipView.ts';
import { clientI18n } from '../../../../shared/scripts/ClientI18n.ts';
import { isDescendantOf } from '../../../../shared/scripts/ui_utils/PixiUtils.ts';
export class UIMGameToolTipController extends UIGameToolTipController {
    createTip(toolTipText, view) {
        this.addTooltipEvent(()=>this.openTip(toolTipText, view), view);
    }
    disableTip(view) {
        super.disableTip(view);
        view.off('pointertap');
        view.off('pointerdown', this.recordPressStart);
    }
    openTip(toolTipText, view) {
        this.closeTip();
        const { title, body, bodyPrefixes } = toolTipText();
        if (clientI18n.t(title.key, title.options) == '' && clientI18n.t(body[0].key, body[0].options) == '') return;
        if (!isDescendantOf(view, this.app.stage)) return;
        this.tip = new UIMGameToolTipView(view, title, body, undefined, bodyPrefixes);
        this.openTipView = view;
        this.autoCloseTimer = setTimeout(()=>this.closeTip(), UIMGameToolTipController.AUTO_CLOSE_DELAY_MS);
    }
    closeTip() {
        clearTimeout(this.autoCloseTimer);
        this.openTipView = null;
        super.closeTip();
    }
    addTooltipEvent(createTooltip, view) {
        this.registerCloseOnTapAndDragOutside();
        view.interactive = true;
        view.on('pointerdown', this.recordPressStart);
        view.on('pointertap', (event)=>{
            this.stopPropagationToBoard(event);
            if (this.shouldIgnoreTooltipTapAfterDrag(event)) return;
            this.toggleTip(createTooltip, view);
        });
    }
    shouldIgnoreTooltipTapAfterDrag(event) {
        const deltaX = event.global.x - this.pressStartPosition.x;
        const deltaY = event.global.y - this.pressStartPosition.y;
        const distanceFromPressStart = Math.hypot(deltaX, deltaY);
        return distanceFromPressStart > UIMGameToolTipController.MAX_TAP_DISTANCE_PX;
    }
    registerCloseOnTapAndDragOutside() {
        if (this.areCloseOnTapAndDragOutsideRegistered) return;
        this.areCloseOnTapAndDragOutsideRegistered = true;
        const mapView = this.uiGameManager.mapController.mapView;
        mapView.on('pointertap', ()=>this.closeTip());
        mapView.on('drag-start', ()=>this.closeTip());
    }
    toggleTip(createTooltip, view) {
        if (this.tipHasParent() && this.openTipView == view) {
            this.closeTip();
            return;
        }
        createTooltip();
    }
    constructor(uiGameManager){
        super(uiGameManager), this.openTipView = null, this.areCloseOnTapAndDragOutsideRegistered = false, this.pressStartPosition = new PIXI.Point(), this.stopPropagationToBoard = (event)=>event.stopPropagation(), this.recordPressStart = (event)=>this.pressStartPosition.copyFrom(event.global);
        this.uiGameManager = uiGameManager;
    }
}
UIMGameToolTipController.AUTO_CLOSE_DELAY_MS = 5000;
UIMGameToolTipController.MAX_TAP_DISTANCE_PX = 15;
